import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchExport,
} from "./uomSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { CallApiExport, showErrorDialog } from "../../utility";
import { UomTable } from "./UomTable";

export const UomPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
    }
    fetchMyAPI();
  }, [dispatch]);

  const paramsFilter = {
    uom_code: code,
    uom_description: name,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Uom">
        <CardHeaderToolbar>
          <Button
            className="btn btn-outline-danger mr-4"
            onClick={() =>
              CallApiExport(paramsFilter, fetchExport, dispatch, "UOM")
            }
          >
            Export
          </Button>
          <Button
            className="btn btn-danger"
            onClick={() => history.push("/master/uom/create")}
          >
            Create
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom Description</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}

        <UomTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
